import styled, {createGlobalStyle} from "styled-components"
import { Link } from 'react-router-dom'

export const mainColor = "#090458";
export const gBackground = "#FCFCFC";
export const mainFont = "Avenir"
export const uBackground = "rgba(0, 128, 128, 0.04)";


 export default createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        outline:0;
        box-sizing:border-box;
        font-family: 'Avenir', sans-serif; 
    }
    #root{
        margin:0 auto;
    }
 `;
 export const BodyText = styled.p`
    color: #8D8D8D;
    font-family: 'Avenir';
    font-weight: 500;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: 0.01em;
    @media screen and (max-width: 768px) {
        line-height: 20px;
        font-style: normal;
        font-weight: 400;
        font-size: 10px;
        letter-spacing: 0.01em;
        text-align: center;
    }
   @media screen and (max-width: 640px){
    .ensureText{
        padding: 10px 0px;
    }
    .hexaVirtualList{
        padding: 10px 20px;
    }
    .virtualDebitCard{
        padding: 10px 20px;
    }
   }
 `
 ;
 export const SaveButton = styled(Link)`
    padding: 18px 60px;
    height: 60px;
    border: 2.5px solid ${mainColor};
    border-radius: 9px;
    color: ${mainColor};
    text-decoration: none;
    &:hover{
        transition: all ease-in-out .3s;
        transform: translateX(3px);
        cursor: pointer;
        opacity: 0.7;
    }
    
    @media screen and (max-width: 768px) {
        height:45px;
        padding: 15px 30px;
        font-size:12px;
        border: 1px solid ${mainColor};
    }
 
 `;